import { BaseEnum, enumCodeToLabel } from "../BaseEnum";

export class AiReportStatus extends BaseEnum {
  static NEW = 1;
  static SUBMITTED = 2;
  static GENERATED = 3;
  static ERROR = 4;

  static Codes = [this.NEW, this.SUBMITTED, this.GENERATED, this.ERROR];

  static _labelKeys = [
    "ai-report.new",
    "ai-report.submitted",
    "ai-report.generated",
    "ai-report.error",
  ];

  static Icons = [
    "mdi-clock-outline",
    "mdi-cog",
    "mdi-check-circle-outline",
    "mdi-alert-circle-outline",
  ];

  static Colors = ["blue", "orange", "green", "red"];

  static codeToIcon(code) {
    return enumCodeToLabel(this.Codes, this.Icons, code);
  }

  static codeToColor(code) {
    return enumCodeToLabel(this.Codes, this.Colors, code);
  }

  static codeToDisplayInfo(code) {
    return {
      icon: this.codeToIcon(code),
      color: this.codeToColor(code),
      label: this.codeToLabel(code),
    };
  }
}
